import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-8',
    header:
      'flex flex-col items-start justify-between gap-4 md:flex-row md:items-center',
    list: 'flex flex-col gap-12 md:gap-20'
  }
});
